<template>
<div class="chapter">
<div class="inner_page">
<div class="Basic-Text-Frame" id="_idContainer001">
<h1 class="Prelims-head" lang="en-GB"><a id="_idTextAnchor000"></a>About the Author</h1>
<p class="Prelims-main" lang="en-GB">Alexander took inspiration from the poetry he learned in A level English. Following Carol Ann Duffy’s lead, he decided to try it out for himself, and his love for the art flourished more. </p>
<p class="Prelims-main" lang="en-GB">His main goal for his poetry is for other people to feel heard and to give voices to those who would otherwise be silent. Using his passion and classes in philosophy to deepen his meanings to his poetry, Alexander intends to continue down this road in the future.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9781035801855_EPUB.vue?57bc4050